module.exports = __webpack_public_path__ + "img/TheMembers-4-pt.75f1d050.png";